<script lang="ts">
	import { getTranslate } from '@tolgee/svelte';
	import { slide } from 'svelte/transition';
	import JourneyListEntry from '../Entries/JourneyListEntry.svelte';

	import ChevronDownIcon from '../Icon/ChevronDownIcon.svelte';

	export let entries: Array<{ name: string | null; slug: string | null }> = [];
	export let tolgeePrefix: string | undefined = undefined;
	export let showTitle: boolean = true;
	// The amount of initially shown entries without show more button press.
	export let initialEntriesAmount: number = 4;

	const { t } = getTranslate();

	let showAllCourses: boolean = false;

	function handleShowAllClick() {
		showAllCourses = !showAllCourses;
	}
</script>

{#if entries.length > 0}
	<div class="flex flex-col min-w-[40%] gap-6 w-full">
		{#if showTitle}
			<div class="text-xl">{$t(`${tolgeePrefix}.journey-list.title`)}</div>
		{/if}
		<div class="flex flex-col border-t border-b border-black divide-y divide-black">
			{#each entries as entry, index}
				{#if index <= initialEntriesAmount - 1}
					<JourneyListEntry course={entry} {index} />
				{/if}
				{#if index > initialEntriesAmount - 1}
					<div
						class="{showAllCourses
							? 'opacity-100'
							: 'opacity-0 -mb-[1px]'} transition-all duration-[450ms]"
					>
						{#if showAllCourses}
							<div transition:slide={{ duration: 450 }}>
								<JourneyListEntry course={entry} {index} />
							</div>
						{/if}
					</div>
				{/if}
			{/each}
			{#if entries.length > initialEntriesAmount}
				<div
					class="{!showAllCourses
						? ''
						: ''} border-r border-l cursor-pointer select-none border-black p-4 bg-white"
					on:click={() => handleShowAllClick()}
					on:keypress={() => handleShowAllClick()}
				>
					<div class="flex flex-row text-purple items-center gap-2">
						<div>
							{showAllCourses
								? `${$t(`${tolgeePrefix}.journey-list.show-less-button`)}`
								: `${$t(`${tolgeePrefix}.journey-list.show-all-button`)}`}
						</div>
						<div class="transition-all duration-300 {showAllCourses ? '-rotate-180' : ''}">
							<ChevronDownIcon additionalClass="w-[20px] h-[20px]" />
						</div>
					</div>
				</div>
			{/if}
		</div>
	</div>
{/if}
